import { render, staticRenderFns } from "./ThgMyVehicleRenewalOptionsSheet.vue?vue&type=template&id=0a4bfdcd&scoped=true&"
import script from "./ThgMyVehicleRenewalOptionsSheet.vue?vue&type=script&lang=ts&"
export * from "./ThgMyVehicleRenewalOptionsSheet.vue?vue&type=script&lang=ts&"
import style0 from "./ThgMyVehicleRenewalOptionsSheet.vue?vue&type=style&index=0&id=0a4bfdcd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4bfdcd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VBtn,VCol,VIcon,VRow,VSheet})
